<template lang="html">
    <div>

        <!-- Header -->
        <div
            class="lightest larger bold d-flex p-2 pointer"
            :class="paymentColor(payment)"
            @click="expandPaymentClick()"
        >
            <div class="flex-grow-1 d-flex justify-content-between">
                <div>
                    {{paymentTitle(payment)}}
                </div>
                <div>
                    {{paymentValue(payment)}}
                </div>
            </div>

            <div>
                <span>{{payment.code}}</span>
                <span class="ml-2">
                    <i v-if="isExpanded == true" class="fas fa-chevron-up"></i>
                    <i v-else class="fas fa-chevron-down"></i>
                </span>
            </div>
        </div>

        <!-- Content -->
        <div v-if="isExpanded == true" class="bg-faded border-light p-2">

            <refund-area
                v-if="thisPaymentRefund"
                :refund="thisPaymentRefund"
                :payment="payment"
                :reservation="reservation"
            />

            <pay-in-area
                v-else
                :payment="payment"
                :reservation="reservation"
                @change="changed()"
            />

            <!-- History -->
            <div
                v-if="payment && payment.historyList && payment.historyList.length > 0"
                class="mt-2"
            >
                <div class="darker bold">History</div>
                <historyPayment
                    v-for="(historyPayment, i) in payment.historyList"
                    :key="i"
                    :payment="historyPayment"
                    :reservation="reservation"
                    :readOnly="true"
                    class="mb-1"
                >
                {{historyPayment}}
                </historyPayment>
            </div>


        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

// areas
import payInArea from './expandedArea/payIn'
import refundArea from './expandedArea/refund'
import historyPayment from '@/tools/modal/ReservationEditV2/TabPayments/expandedArea/historyPayment'

export default {
    created: function () {
        // Set refund as expanded if the link contains the same id, example: localhost:8081/reservations/view/27656?refundId=3#refunds
        if(this.$route.query.refundId && this.$route.query.refundId == this.payment.id){
            this.isExpanded = true
        }
    },
    props: {
        reservation:{
            type: Object
        },
        payment: {
            type: Object,
            default: null,
            required: true
        },
        refunds: {
            type: Array,
            default: function () {
                return []
            }
        },
        isUnsavedRefund: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            isExpanded: false,
        }
    },
    computed: {
        ...mapGetters([
            'getRefundReasons',
            'getPercentageOrCurrency',
            'getPaymentTypeListAll',
            'getRefundStatus'
        ]),
        isUnsavedPayment: function () {
            return this.payment.id == null
        },
        isRefund: function () {
            // return this.payment.description.includes('Refund')
            return (this.payment.refundId && this.payment.refundId != null)
        },
        thisPaymentRefund: function () {
            if(this.isUnsavedRefund){
                return this.payment.refundObj
            }
            if(!this.isRefund){
                return false
            } else {
                return this.refunds.find(refund => {
                    return refund.id == this.payment.refundId
                })
            }
        }
    },
    methods: {
        ...mapActions([
            'openModal',
            'executeRefund',
            'selectRefund',
        ]),
        paymentTitle: function (payment) {
            let titleArray = []

            if(this.paymentDate(payment)){
                titleArray.push(this.paymentDate(payment))
            }

            if(this.isUnsavedPayment){
                titleArray.push('Unsaved ')
            }

            if(this.paymentStatus(payment)){
                titleArray.push(this.paymentStatus(payment))
            }
            if(this.payemntMethod(payment)){
                titleArray.push(this.payemntMethod(payment))
            }
            if(this.paymentChannel(payment)){
                titleArray.push(this.paymentChannel(payment))
            }
            // if(this.paymentValue(payment)){
            //     titleArray.push(this.paymentValue(payment))
            // }

            return titleArray.join(' - ')
        },
        expandPaymentClick: function () {
            this.isExpanded = !this.isExpanded
        },
        paymentDate: function (payment) {
            return moment(payment.date).format("YYYY-MM-DD HH:mm")
        },
        paymentStatus: function (payment) {
            if(this.isUnsavedRefund){
                return 'Unsaved Refund'
            }

            if(payment.paymentDirection == 0){
                return 'Pay In'
            } else {
                if(!this.isRefund){
                    return 'Pay Out'
                } else if(this.thisPaymentRefund){
                    let foundStatus = this.getRefundStatus.find(status => status.id == this.thisPaymentRefund.status)
                    return foundStatus? foundStatus.label : ''

                } else {
                    return 'Loading'
                }
            }

        },
        payemntMethod: function (payment) {
            if(this.isUnsavedRefund){
                let foundPyamentMethod =  this.getPaymentTypeListAll.find(pm => pm.id == payment.refundObj.paymentType)
                return foundPyamentMethod? foundPyamentMethod.description : null
            } else {
                let foundPyamentMethod =  this.getPaymentTypeListAll.find(pm => pm.id == payment.type)
                return foundPyamentMethod? foundPyamentMethod.description : null
            }
        },
        paymentChannel: function (payment) {
            if(this.isUnsavedRefund){
                return payment.refundObj.refundChannels[0].brandName
            }
            // return 'paymentChannel'
            if(payment.treasurerUserAccount){
                return
            } else if(this.reservation.channelTypeDescription) {
                return this.reservation.channelTypeDescription
            } else {
                return null
            }
        },
        paymentColor: function (payment) {
            if(this.isUnsavedRefund || this.isUnsavedPayment){
                return 'bg-color-1'
            }

            if(payment.paymentDirection == 0){
                return 'bg-color-3'
            } else {
                if(!this.isRefund){
                    return 'bg-color-6'
                } else if(this.thisPaymentRefund){
                    let foundStatus =this.getRefundStatus.find(status => status.id == this.thisPaymentRefund.status)
                    return foundStatus? 'bg-'+foundStatus.color : ''
                } else {
                    return 'bg-color-1'
                }
            }
        },
        paymentValue: function (payment) {
            if(this.isUnsavedRefund){
                return this.formatPrice(payment.refundObj.amountResumeValue) + '€'
            }

            return this.formatPrice(payment.value) + '€'
        },
        changed: function () {
            this.$set(this.reservation.updateFlags, 'billing', true)
        }
    },
    components: {
        payInArea,
        refundArea,
        historyPayment
    }
}
</script>

<style lang="scss" scoped>
@keyframes blink {
    0% {
        opacity: 0;
    }
    33% {
        opacity: 1;
    }
    66% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.btnMarkAsRefunded{
        animation: 1s ease-out 0s 1 blink;
}
</style>



// WEBPACK FOOTER //
// paymentSingleRow.vue?0f411d2f